module.exports = __webpack_public_path__ + "static/media/link-now-button.cb7bef1f.png";